// Single place to update each legal page's "Last updated" date. Kept per-page
// rather than one shared constant, since updating one document shouldn't
// change the displayed date on the others.
export const LEGAL_LAST_UPDATED = {
  privacy: '12 September 2026',
  terms: '12 September 2026',
  cookies: '12 September 2026',
} as const;
